'use strict';

var Facade = require('./facade');

/**
 * Expose specific-method facades.
 */

Facade.Alias = require('./alias');
Facade.Group = require('./group');
Facade.Identify = require('./identify');
Facade.Track = require('./track');
Facade.Page = require('./page');
Facade.Screen = require('./screen');

/**
 * Exports.
 */

module.exports = Facade;



//////////////////
// WEBPACK FOOTER
// ../~/segmentio-facade/lib/index.js
// module id = 2988
// module chunks = 0